module.exports = __webpack_public_path__ + "static/media/iconLead.64f18532.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/serviceicon2/iconLead.svg
// module id = 437
// module chunks = 0